@if (!hide) {
    @if (!isStaff) {
        <div class="shieldCircle" [matTooltip]="isOnline? 'Online':'Offline'"
             [class.isOnline]="isOnline">
        </div>
    }
    @if (isStaff) {
        <div class="shieldCircle" [matTooltip]="isOnline? 'Moderator, Online':'Moderator, Offline'"
             [class.isOnline]="isOnline">
            <mat-icon>verified_user</mat-icon>
        </div>
    }
}
@if (hide && isStaff) {
    @if (isStaff) {
        <div class="shieldCircle" [matTooltip]="'Moderator'">
            <mat-icon>verified_user</mat-icon>
        </div>
    }
}
